var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z",
    fill: "#0B0B0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.194 4c.105.711-.184 1.408-.566 1.9-.409.53-1.113.938-1.795.917-.124-.681.194-1.382.582-1.854.426-.52 1.155-.92 1.78-.963zm2.05 10.009c.352-.539.483-.81.756-1.42-1.986-.755-2.304-3.578-.339-4.661-.6-.752-1.441-1.188-2.236-1.188-.573 0-.966.15-1.323.286-.297.113-.57.217-.901.217-.359 0-.676-.114-1.008-.233-.365-.13-.748-.268-1.224-.268-.892 0-1.842.545-2.444 1.477-.846 1.313-.702 3.78.67 5.883.491.752 1.147 1.598 2.004 1.605.356.004.593-.102.849-.217.293-.132.612-.275 1.164-.278.555-.003.868.142 1.158.275.25.115.48.222.833.218.859-.007 1.55-.944 2.04-1.696z",
    fill: "#fff"
  })));
}
export default SvgApple;